<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(color="primary" v-on="on" text) {{button}}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-btn(@click="visible = !visible" color="primary" icon)
          v-icon(dark) mdi-pencil
        BaseDefinitionList(v-if="visible", :items="getDetailsItem(freerounds)" keysAlign="text-left text-sm-right")
        p(v-else) formulario pendiente
        //- OperatorProviderEdit(v-else :clearForm="!visible", :translations="translations", :operator="operator", :provider="provider" @successEdit="update()")
</template>

<script>

  // import OperatorProviderEdit from '@/components/forms/OperatorProviderEdit';

  export default {
    name: "FreeroundsEditDialog",
    components: {
      // OperatorProviderEdit,
    },
    props:{
      title:{
        type: String,
        default: ''
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      button:{
        type: String,
        default: ''
      },
      freerounds:{
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() => ({
      dialog: false,
      visible: true,
    }),
    computed: {
      // translations() {
      //   return this.$t("forms.operatorProviderCreateEdit");
      // },
    },
    watch: {
      dialog: function(){
        this.visible = true;
      },
    },
    methods:{
      getDetailsItem(item){
        let fields = [
          {
            key: 'Nombre:',
            value: item.name
          },
          {
            key: 'Fecha de inicio:',
            value: item.startdate
          },
          {
            key: 'Fecha de fin:',
            value: item.enddate
          },
          {
            key: 'Proveedor:',
            value: item.provider
          },
          {
            key: 'Juego id:',
            value: item.gameId
          },
          {
            key: 'Player id:',
            value: item.playerId
          },
          {
            key: 'Promotion id:',
            value: item.promotionId
          },
          {
            key: 'Cantidad de freeRoundCount:',
            value: item.freeRoundCount
          },
          {
            key: 'Cantidad otorgada:',
            value: item.amount
          },
        ];
        // if (this.item.api != '' && this.item.api != undefined){
        //   fields.push({
        //     key: 'API:',
        //     value: item.api
        //   });
        // }
        // if (this.item.url != '' && this.item.url != undefined){
        //   fields.push({
        //     key: 'URL:',
        //     value: item.url
        //   });
        // }
        // if (this.item.k1 != '' && this.item.k1 != undefined){
        //   fields.push({
        //     key: 'key 1:',
        //     value: item.k1
        //   });
        // }
        // if (this.item.k2 != '' && this.item.k2 != undefined){
        //   fields.push({
        //     key: 'key 2:',
        //     value: item.k2
        //   });
        // }
        // if (this.item.k3 != '' && this.item.k3 != undefined){
        //   fields.push({
        //     key: 'key 3:',
        //     value: item.k3
        //   });
        // }
        // if (this.item.cap != '' && this.item.cap != undefined){
        //   fields.push({
        //     key: 'cap:',
        //     value: item.cap
        //   });
        // }
        // if (this.item.ggr != '' && this.item.ggr != undefined){
        //   fields.push({
        //     key: 'ggr:',
        //     value: item.ggr
        //   });
        // }
        // if (item.params != undefined && Object.keys(item.params).length){
        //   Object.keys(item.params).forEach((item) => {
        //     fields.push({
        //       key: item+':',
        //       value: item.params[item]
        //     });
        //   });
        // }
        return fields;
      },
      // update(){
      //   if(this.dialog){
      //     this.visible = true;
      //     this.$emit('successEdit');
      //   }
      // },
    }
  }

          // {
          //   _id: '123',
          //   name: 'test 1',
          //   startdate: '01/10/2020',
          //   enddate: '05/10/2020',
          //   provider: 'id789',
          //   enabled: true,
          //   fields: {
          //     publicKey: 'Test',
          //     gameId: 1234,
          //     playerId: 2345,
          //     promotionId: 3456,
          //     freeRoundCount: 7,
          //     currency: 'EU',
          //     amount: 89,
          //   },
          // },
</script>

<style lang="sass">
</style>